export const FIRECHAIN_TOKEN_WHITELIST = []
export const FIRECHAIN_TOKEN_BLACKLIST = []